// JsFromRoutes CacheKey bca1368f80498268f066fe26b6189527
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { definePathHelper } from 'utils/js_from_routes_client'

export default {
  index: /* #__PURE__ */ definePathHelper('get', '/public/marketplace'),
  show: /* #__PURE__ */ definePathHelper('get', '/public/marketplace/:product_slug'),
}
